import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_pentecost-portal/artifacts/yi2c4y36_MoJ_LOGO_Web.png';
export const CHURCH = {
  name: 'Ministry of Jesus',
  scripture: 'Zechariah 4:6',
  motto: 'Not by might, nor by power, but by the Spirit of God.',
  tagline: 'To Know Christ and Make Him Known in Ireland',
  address: '7 Le Fanu Rd, Ballyfermot Rd, Cherry Orchard, Dublin, D10 NH74',
  phone: '087 231 9966',
  phoneIntl: '+353 87 231 9966',
  email: 'pastor@ministryofjesus.ie',
  emailInfo: 'info@ministryofjesus.ie',
  website: 'www.ministryofjesus.ie',
  youtube: 'https://www.youtube.com/@MinistryofJesus',
  serviceTime: 'Sundays at 10:30',
  morningPrayer: {
    title: 'Early Morning Prayer',
    schedule: 'Every Monday 5:00 AM – 6:00 AM',
    meetUrl: 'https://meet.google.com/udf-qxfc-mub',
    meetCode: 'udf-qxfc-mub',
    timezone: 'Europe/Dublin',
    day: 1, // Monday
    startHour: 5,
    endHour: 6,
  },
};

// Comprehensive ministry calendar (from official church poster)
export const SCHEDULE = {
  weekly: [
    { name: 'Sunday School',        when: 'Every Sunday',     time: '09:30 AM' },
    { name: 'Sunday Worship',       when: 'Every Sunday',     time: '10:30 AM' },
    { name: 'Early Morning Prayer', when: 'Every Monday',     time: '05:00 – 06:00 AM', meet: true },
    { name: 'Care Cell Meeting',    when: 'Every Tuesday',    time: '07:00 – 08:00 PM', note: 'Multi-location across Ireland' },
    { name: 'House Visit by Prayer Team', when: 'Every Wednesday', time: '07:00 PM' },
    { name: 'Freedom & Healing Prayer', when: 'Every Thursday', time: '10:00 AM – 12:00 PM' },
    { name: 'G-Will Music School',  when: 'Every Sunday',     time: '01:00 – 03:00 PM' },
  ],
  monthly: [
    { name: 'Holy Communion Service',     when: '1st Sunday',     time: '10:30 AM' },
    { name: 'Evangelism on the Street',   when: '1st Saturday',   time: '' },
    { name: 'Mid Week Prayer Service',    when: '1st & 3rd Friday', time: '07:00 – 08:30 PM' },
    { name: 'Youth Evening (12y & above)',when: '2nd Friday',     time: '06:30 PM' },
    { name: 'Fasting Prayer',             when: '2nd Saturday',   time: '10:30 AM' },
    { name: 'Arise & Shine (Children Club)', when: '3rd Saturday', time: '09:30 AM – 02:30 PM' },
    { name: 'Night Vigil Prayer',         when: 'Last Friday of month', time: '08:00 PM – 12:00 AM' },
  ],
};

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// SECURITY NOTE on token storage:
// Admin/Pastor and Team Leader JWTs are stored in localStorage so the SPA can
// attach them via the Authorization header. localStorage is vulnerable to XSS,
// so we mitigate by: (1) strict React rendering (no dangerouslySetInnerHTML),
// (2) trusted dependency surface, (3) short JWT lifetime (12 h),
// (4) audit-logged sensitive actions on the backend. For production hardening,
// migrate these flows to httpOnly cookies + CSRF tokens (Phase 3).
// Members already use httpOnly cookies (Emergent Google Auth) — the safer path.
api.interceptors.request.use((config) => {
  const adminToken = localStorage.getItem('moj_admin_token');
  const teamToken = localStorage.getItem('moj_team_token');
  // Admin/Pastor routes use admin token; team routes use team token; others rely on cookie
  if (config.url) {
    if (config.url.startsWith('/admin') || config.url.startsWith('/pastor')) {
      if (adminToken) config.headers.Authorization = `Bearer ${adminToken}`;
    } else if (config.url.startsWith('/teams')) {
      if (teamToken) config.headers.Authorization = `Bearer ${teamToken}`;
    }
  }
  return config;
});

export default api;
